<template>
    <div class="list-supervisors" data-infinite-scroll>
        <panel-search @search="search" placeholder="Введите фио, телефон или почту для поиска"
                      class="panel-search-light"></panel-search>

        <table class="table table-striped">
            <thead>
            <tr>
                <th>ФИО</th>
                <th>Привязанный салон</th>
                <th>Логин</th>
                <th>Телефон</th>
                <th>E-mail</th>
                <th>Работ. с</th>
                <th>Уволен</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="supervisor in supervisors">
                <td>
                    <a :href="`/supervisors/${supervisor.id}`">{{ supervisor.full_name }}</a>
                </td>
                <td>{{ (supervisor.salon) ? supervisor.salon.name : '' }}</td>
                <td>{{ supervisor.login }}</td>
                <td>{{ supervisor.phone }}</td>
                <td>{{ supervisor.email }}</td>
                <td v-if="supervisor.start_salon">{{ supervisor.start_salon | date_format('DD.MM.YYYY HH:mm') }}</td>
                <td v-else></td>
                <td v-if="supervisor.end_salon">{{ supervisor.end_salon | date_format('DD.MM.YYYY HH:mm')}}</td>
                <td v-else></td>
            </tr>
            </tbody>
        </table>

        <button class="load-more" v-if="next_page_url" @click="loadNextPage">Еще</button>
    </div>
</template>

<script>
    import axios from 'axios'
    import _ from 'lodash'
    import 'waypoints/lib/jquery.waypoints.js'

    export default {
        props: {
            activated: {
                default: 1,
            },
        },
        data(){
            return {
                q: '',
                loading_next_page: null,
                next_page_url: null,
            }
        },
        asyncComputed: {
            supervisors() {
                return axios
                    .get('/api/supervisors', {
                        params: {
                            q: this.q,
                            activated: this.activated,
                        }
                    })
                    .then(({data}) => {
                        this.next_page_url = data.next_page_url
                        return data.data
                    })
            },
        },
        methods: {
            search(q) {
                this.q = q
            },
            loadNextPage() {
                if (!this.loading_next_page) {
                    this.loading_next_page = axios
                        .get(this.next_page_url)
                        .then(({data}) => {
                            this.next_page_url = data.next_page_url
                            this.supervisors = this.supervisors.concat(data.data)
                        })
                        .finally(() => this.loading_next_page = null)
                }
            },
        },
        mounted() {
            // Infinite scroll
            var infContainer = $('[data-infinite-scroll]')
            if (!infContainer.length) return
            var self = this

            infContainer.waypoint({
                handler: function (direction) {
                    if (direction == 'down' && self.next_page_url) {
                        if (this.triggerPoint >= 0) {
                            self.loadNextPage()
                        }
                    }
                },
                offset: 'bottom-in-view'
            })
        }
    }
</script>



// WEBPACK FOOTER //
// ListSupervisors.vue?28747e74